import { ActivatedRoute } from '@angular/router';

/**
 * Recursively searches for the first ActivatedRoute in the tree with the given param in its snapshot.
 * @param route - Root or nested route to begin traversal from
 * @param param - Param key to search for
 * @returns ActivatedRoute containing the param, or null if not found
 */
export const findRouteWithParam = (
  route: ActivatedRoute | null | undefined,
  param: string
): ActivatedRoute | null => {
  if (!route) return null;

  if (route.snapshot?.paramMap?.has(param)) {
    return route;
  }

  for (const child of route.children) {
    const found = findRouteWithParam(child, param);
    if (found) return found;
  }

  return null;
};
